import { IComponentOptions, IController, IScope } from "angular";
import colors from "wwwroot/json/colors.json";
import { Aggregation, aggregations, DEFAULT_LIST_CHART_AGGREGATION, DEFAULT_LIST_CHART_COLOR, IListChartSettings, IListProperty, ListTypeChangeEventArgs } from "../..";
import { GtmhubController } from "@gtmhub/core";
import { ChartSettingsLoader } from "../../services/chart-settings-loader";
import { IModalComponent } from "@gtmhub/core/routing";

export type ChartSettingsResolve = {
  listProperties: IListProperty[];
};
// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface IChartSettingsResolve extends IModalComponent<ChartSettingsResolve> {}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface ChartSettingsComponentCtrl extends IChartSettingsResolve {}

export class ChartSettingsComponentCtrl extends GtmhubController implements IController {
  chartCategory: IListProperty;
  chartValue: IListProperty;
  aggregation: Aggregation;
  color: string;
  listProperties: IListProperty[];
  colors = colors.general;
  readonly aggregations = aggregations;

  public static $inject = ["$scope", "ChartSettingsLoader"];
  constructor(private $scope: IScope, private chartSettingsLoader: ChartSettingsLoader) {
    super();
  }

  $onInit(): void {
    this.listProperties = this.resolve.listProperties;
    this.setDefaultsOrSelectedValues();
    const chartSettings = this.constructChartSettings();
    this.chartSettingsLoader.resolve(chartSettings);
    this.$scope.$on("listTypeChange", (event, args: ListTypeChangeEventArgs) => this.onListTypeChange(args));
    this.$scope.$on("chartSettingsChange", (event, args: string) => this.setChartSettings(args));
  }

  onColumnChange(): void {
    this.onChartSettingsChange();
  }

  onAggregationChange(): void {
    this.onChartSettingsChange();
  }

  toggleAggregation(): void {
    this.aggregation = this.aggregation ? null : "Count";
    this.onAggregationChange();
  }

  onColorChange(c: string): void {
    this.color = c;
    this.onChartSettingsChange();
  }

  // TODO: Take into account persisted values
  private setDefaultsOrSelectedValues(): void {
    this.color = DEFAULT_LIST_CHART_COLOR;
    this.chartCategory = this.listProperties[0];
    this.chartValue = this.listProperties[1];
    this.aggregation = DEFAULT_LIST_CHART_AGGREGATION;
  }

  private onChartSettingsChange(): void {
    const chartSettings = this.constructChartSettings();
    this.chartSettingsLoader.chartSettingsChange(chartSettings, ChartSettingsComponentCtrl.name);
  }

  private setChartSettings(changedFrom: string): void {
    if (changedFrom !== ChartSettingsComponentCtrl.name) {
      const settings = this.chartSettingsLoader.chartSettings;
      this.chartCategory = settings.chartCategory;
      this.chartValue = settings.chartValue;
      this.aggregation = settings.aggregation;
      this.color = settings.color;
    }
  }

  private onListTypeChange(args: ListTypeChangeEventArgs): void {
    this.listProperties = args.listProperties;
  }

  private constructChartSettings(): IListChartSettings {
    return {
      chartCategory: this.chartCategory,
      chartValue: this.chartValue,
      aggregation: this.aggregation,
      color: this.color,
    };
  }
}

export const ChartSettingsComponent: IComponentOptions = {
  templateUrl: require("./chart-settings.component.jade"),
  controller: ChartSettingsComponentCtrl,
  bindings: {
    resolve: "<",
    close: "&",
    dismiss: "&",
  },
};
